export default __webpack_public_path__ + "img/right-arrow.b424e6c.svg";